import { combineReducers } from '@reduxjs/toolkit';
import lunaStreamsReducers from '@vlabs/monokit/entities/sources/luna-streams/store/reducer';

import accountsSlice from '@vlabs/pages/accounts/store';
import accountSlice from '@vlabs/pages/auth/store';
import eventsSlice from '@vlabs/pages/events/events/store';
import handlerSlice from '@vlabs/pages/handlers/store';
import listsSlice from '@vlabs/pages/lists/store';
import notificationsSlice from '@vlabs/pages/notifications/store';
import videoAnalyticsSlice from '@vlabs/pages/video-analytics/store';
import videoWallSlice from '@vlabs/shared/video-wall/store';
import workspaceSlice from '@vlabs/pages/point/workspace/store';

import appSlice from './appSlice';

export const rootReducer = combineReducers({
  app: appSlice,
  account: accountSlice,
  accounts: accountsSlice,
  lists: listsSlice,
  events: eventsSlice,
  workspace: workspaceSlice,
  handlers: handlerSlice,
  notifications: notificationsSlice,
  videowall: videoWallSlice,
  videoAnalytics: videoAnalyticsSlice,
  ...lunaStreamsReducers,
});
